import type { FavoritesConfig } from '#types/config/components/favorites'
import type { RecursivePartial } from '#types/utils'

export default {
  buttonVariants: {
    createAccount: 'tertiary'
  }
} satisfies RecursivePartial<FavoritesConfig>
